// extracted by mini-css-extract-plugin
export default {"tableTitle":"tableComponent_tableTitle__WThU2","tableTop":"tableComponent_tableTop__obUfT","mps":"tableComponent_mps__OgoAk"};